import React from 'react';
import type { TextComponentConfig } from '@/types/page';
import { getSpacingStyle, getTextPresetClasses } from '@/utils/pageUtils';
import { cn } from '@/utils/cn';

interface TextComponentProps {
  config: TextComponentConfig;
}

export default function TextComponent({ config }: TextComponentProps) {
  if (!config.content) {
    return null;
  }

  // 1. 获取预设样式的 Tailwind 类名
  const presetClasses = config.style ? getTextPresetClasses(config.style) : '';

  // 2. 构建自定义样式（会覆盖预设样式）
  const customStyle: React.CSSProperties = {};

  if (config.fontSize && config.fontSize !== 'auto') {
    customStyle.fontSize = config.fontSize;
  }

  if (config.color) {
    customStyle.color = config.color;
  }

  if (config.textAlign) {
    customStyle.textAlign = config.textAlign as any;
  }

  if (config.fontWeight) {
    customStyle.fontWeight = config.fontWeight;
  }

  // 3. 应用 spacing 样式
  const spacingStyle = getSpacingStyle(config.spacing);

  // 4. 合并所有样式：预设 < 自定义 < spacing
  const mergedStyle: React.CSSProperties = {
    ...customStyle,
    ...spacingStyle,
  };

  // 5. 渲染内容
  const content = (
    <div className={cn(presetClasses)} style={mergedStyle}>
      {config.content}
    </div>
  );

  // 6. 如果有链接，包裹 <a> 标签
  if (config.link) {
    return (
      <a href={config.link} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  return content;
}
